module.exports = __webpack_public_path__ + "5b4b6e5c892f752644de5cf9974e149d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/space-vision-house-empty.png
// module id = 342
// module chunks = 0